import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import React from 'react';
import { useEmailUtilityAutomationListQuery } from '../../domain/email-utility-automation/queries';
import { IProgram } from '../../domain/program/interface';
import { getEmailUtilityAutomationTitle } from '../table/columnFormatHelpers';
import { VenInfo } from '../VenInfo/VenInfo';

export const ProgramUtilityAutomations: React.FC<{ program: IProgram }> = ({ program }) => {
    const { data: emailUtilityAutomationsData } = useEmailUtilityAutomationListQuery({});
    const emailUtilityAutomations = emailUtilityAutomationsData || [];

    const emailUtilityAutomationTitle = program?.utility_automation
        ? getEmailUtilityAutomationTitle(program.utility_automation, emailUtilityAutomations)
        : null;

    const cloudVens = program?.cloudVens || [];

    return (
        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline', gap: '4px', maxWidth: '100%' }}>
            {emailUtilityAutomationTitle && (
                <Tooltip placement="topLeft" title={emailUtilityAutomationTitle}>
                    <Typography.Text ellipsis>{emailUtilityAutomationTitle}</Typography.Text>
                </Tooltip>
            )}
            {cloudVens.map(ven => (
                <VenInfo ven={ven} key={`ven-info-${ven.id}`} />
            ))}
        </span>
    );
};
